
import { api } from '../core';
import { SubscriptionRecord } from '../../types';
import { MOCK_SUBSCRIPTIONS } from '../mockData';

const mapToUI = (apiSub: any): SubscriptionRecord => {
    return {
        id: apiSub.id,
        planId: apiSub.plan?.name?.toLowerCase().includes('pro') ? 'pro' : 
                apiSub.plan?.name?.toLowerCase().includes('enterprise') ? 'enterprise' : 'free',
        status: apiSub.status || 'active',
        startDate: new Date(apiSub.startDate).getTime(),
        endDate: apiSub.currentPeriodEnd ? new Date(apiSub.currentPeriodEnd).getTime() : null,
        autoRenew: !apiSub.cancelAtPeriodEnd,
        price: apiSub.plan?.price + ' SAR'
    };
};

export const BillingService = {
  getSubscriptions: async (): Promise<SubscriptionRecord[]> => {
    return api.execute<SubscriptionRecord[]>(
      '/api/V1/Subscription/GetAllByLanguage',
      async () => {
        const saved = localStorage.getItem('lahja_subscriptions');
        return saved ? JSON.parse(saved) : [];
      },
      { mockDelay: 600 }
    ).then(res => {
        if (Array.isArray(res) && res.length > 0 && 'currentPeriodEnd' in res[0]) {
            return res.map(mapToUI);
        }
        return res as SubscriptionRecord[];
    });
  },

  cancelSubscription: async (id: string): Promise<boolean> => {
    return api.execute<boolean>(
      `/api/V1/Subscription/Update/${id}`,
      true, 
      { method: 'PUT', body: { id, body: { cancelAtPeriodEnd: true } } }
    );
  },

  pauseSubscription: async (id: string): Promise<boolean> => {
    return api.execute<boolean>(
      `/api/V1/Subscription/Update/${id}`,
      true, 
      { method: 'PUT', body: { id, body: { status: 'paused' } } }
    );
  },

  resumeSubscription: async (id: string): Promise<boolean> => {
    return api.execute<boolean>(
      `/api/V1/Subscription/Update/${id}`,
      true,
      { method: 'PUT', body: { id, body: { status: 'active' } } }
    );
  },

  renewSubscription: async (id: string): Promise<boolean> => {
    return api.execute<boolean>(
      `/api/V1/Subscription/Update/${id}`,
      true,
      { method: 'PUT', body: { id, body: { cancelAtPeriodEnd: false } } }
    );
  }
};
